import React, { useEffect, useState } from 'react';
import SectionTitle from '../Common/SectionTitle';
import { Link } from 'react-router-dom';

const TallyPrime = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [activeTab, setActiveTab] = useState('single');

  // Use process.env.PUBLIC_URL for image paths
  const imagePaths = {
    heroImg: 'https://onlineretailhub.in/wp-content/uploads/2020/07/tally-cloud-3.png',
    tallyCloudImg: 'https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/prime-page-banner-right-img.webp',
    tallyFeatureImg: 'https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/accounting-inventory-e-invoicing-and-more-all-in-one-software.webp',
    tallyMobileImg: 'https://resources.tallysolutions.com/bd/en/wp-content/themes/tally/assets/images/run-your-business.webp',
    tallyAwsImg: 'https://resources.tallysolutions.com/bd/en/wp-content/themes/tally/assets/images/tally-software-service/tss-banner.png',
    heroBgImg: `${process.env.PUBLIC_URL}/assets/img/hero-bg-2.jpg`,
    testimonialsBgImg: `${process.env.PUBLIC_URL}/assets/img/testimonials-bg.jpg`
  };
  
  // Set correct page title and scroll to top when component mounts
  useEffect(() => {
    document.title = "TallyPrime Solutions | Digisoft";
    window.scrollTo(0, 0);
    
    // Remove header manipulation code - we want to use the default header
    
    // Add Font Awesome script for icons - fixed integrity issue
    const fontAwesomeScript = document.createElement('script');
    fontAwesomeScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/js/all.min.js'; 
    // Remove integrity check causing the error
    fontAwesomeScript.crossOrigin = 'anonymous';
    document.head.appendChild(fontAwesomeScript);
    
    // Apply Roboto Regular font to the entire site
    const fontStyle = document.createElement('style');
    fontStyle.textContent = `
      * {
        font-family: "Roboto Regular", "Roboto", sans-serif !important;
      }
      
      /* Keep special styling for price numbers */
      .price-amount {
        font-family: "Roboto Regular", "Roboto", sans-serif !important;
        font-weight: 700 !important;
      }
    `;
    document.head.appendChild(fontStyle);
    
    // Add CSS for logos slider
    const style = document.createElement('style');
    style.textContent = `
      .logos-slider {
        overflow: hidden;
        padding: 20px 0;
        white-space: nowrap;
        position: relative;
      }
      
      .logos-slide {
        display: inline-block;
        animation: slide 20s linear infinite;
      }
      
      .client-logo {
        height: 80px;
        margin: 0 40px;
        vertical-align: middle;
        filter: grayscale(100%);
        opacity: 0.7;
        transition: all 0.3s ease;
      }
      
      .client-logo:hover {
        filter: grayscale(0%);
        opacity: 1;
      }
      
      @keyframes slide {
        0% {
          transform: translateX(0);
        }
        100% {
          transform: translateX(-100%);
        }
      }

      /* Pricing styles */
      .pricing-tab-btn {
        min-width: 150px;
        padding: 8px 16px;
        border: 0;
        outline: 0;
        background-color: #f8f9fa;
        transition: all 0.3s ease;
        cursor: pointer;
        border-radius: 0;
        font-weight: 500;
        color: #666;
      }

      .pricing-tab-btn:first-child {
        border-top-left-radius: 25px;
        border-bottom-left-radius: 25px;
      }

      .pricing-tab-btn:last-child {
        border-top-right-radius: 25px;
        border-bottom-right-radius: 25px;
      }

      .pricing-tab-btn:hover:not(.active) {
        background-color: #e9ecef;
        color: #333;
      }

      .pricing-tab-btn.active {
        background-color: #0d6efd;
        color: white;
        font-weight: 700 !important;
        opacity: 1 !important;
        box-shadow: 0 2px 5px rgba(0,0,0,0.2);
        position: relative;
        z-index: 1;
      }

      .pricing-tab-container {
        display: inline-flex;
        padding: 0;
        background-color: #f8f9fa;
        border-radius: 25px;
        box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        overflow: hidden;
      }

      .pricing-tab-btn:active {
        outline: none !important;
        border: 0 !important;
      }

      .pricing-section {
        display: none;
      }

      .pricing-section.active {
        display: flex;
        flex-wrap: wrap;
      }

      .pricing-card {
        border: 1px solid #dee2e6;
        border-radius: 10px;
        padding: 20px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      .pricing-card ul {
        font-size: 1rem;
        padding: 0;
        margin: 0;
        list-style-type: none;
      }

      .pricing-card ul li {
        padding-left: 26px;
        background-size: 15px;
        line-height: 1.9rem;
        position: relative;
      }

      .pricing-card ul li::before {
        content: "✓";
        position: absolute;
        left: 5px;
        color: #666;
      }

      .pricing-card .pricing-price {
        font-size: 1.5rem;
        font-weight: 600;
      }

      .pricing-checklist li {
        padding-left: 24px;
        background-position: left 7px;
        background-repeat: no-repeat;
        position: relative;
      }

      .pricing-checklist li::before {
        font-family: "bootstrap-icons";
        content: "\\F633";
        position: absolute;
        left: 0;
        color: var(--color-primary);
      }

      .pricing-card .pricing-effective {
        color: var(--color-primary);
        min-height: 22px;
      }

      .hover-text {
        position: relative;
        display: inline-block;
        cursor: pointer;
      }

      .hover-text span {
        visibility: hidden;
        background-color: #444;
        color: #fff;
        text-align: center;
        border-radius: 5px;
        padding: 10px;
        position: absolute;
        bottom: 100%;
        left: 60%;
        transform: translateX(-50%);
        z-index: 1;
        width: 280px;
        font-size: 0.9rem;
        line-height: normal;
      }

      .hover-text:hover span {
        visibility: visible;
      }

      .off-tag {
        position: absolute;
        right: -5px;
        top: 15px;
        background-color: #ff4757;
        color: white;
        padding: 2px 8px;
        border-radius: 3px;
        font-size: 0.8rem;
        font-weight: bold;
      }

      .bg-light-cream {
        background-color: #f8f9fa;
      }

      /* Premium price styling */
      .price-value {
        font-family: 'Poppins', sans-serif;
        letter-spacing: -0.5px;
      }

      .price-currency {
        font-size: 1rem;
        font-weight: 500;
        position: relative;
        top: -0.5rem;
        margin-right: 2px;
      }

      .price-amount {
        font-size: 2.2rem;
        font-weight: 700;
        background: linear-gradient(135deg, #0d6efd 0%, #0099ff 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .price-deleted {
        font-size: 1.1rem;
        opacity: 0.7;
      }
    `;
    document.head.appendChild(style);

    // Check if mobile view
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 992);
    };
    
    // Initial check
    checkIfMobile();
    
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    
    return () => {
      document.title = "Digisoft Services";
      window.removeEventListener('resize', checkIfMobile);
      document.head.removeChild(style);
      document.head.removeChild(fontStyle); // Remove font style when component unmounts
      document.head.removeChild(fontAwesomeScript); // Clean up Font Awesome script
    };
  }, []);

  // Function to switch between pricing tabs
  const switchPricingTab = (type) => {
    setActiveTab(type);
    
    // Update active tab display
    const singleTab = document.querySelector('.pricing-tab-btn:nth-child(1)');
    const multiTab = document.querySelector('.pricing-tab-btn:nth-child(2)');
    
    if (type === 'single') {
      singleTab?.classList.add('active');
      multiTab?.classList.remove('active');
      
      // Show single pricing section, hide multi
      document.getElementById('pricing-single')?.classList.add('active');
      document.getElementById('pricing-multi')?.classList.remove('active');
    } else {
      multiTab?.classList.add('active');
      singleTab?.classList.remove('active');
      
      // Show multi pricing section, hide single
      document.getElementById('pricing-multi')?.classList.add('active');
      document.getElementById('pricing-single')?.classList.remove('active');
    }
  };

  const tallyPrimeSolutions = [
    {
      title: 'Buy TallyPrime',
      description: 'Your financial and accounting procedures can be greatly streamlined by purchasing a full TallyPrime license. By purchasing TallyPrime from Digisoft, you get access to a top-notch accounting and financial management program that is designed to expand together with your company.',
      icon: 'cart-check'
    },
    {
      title: 'Renewal TallyPrime',
      description: 'Renewal is necessary for current TallyPrime users to keep their software current and their businesses operating properly. You\'ll never lose out on the newest features and upgrades thanks to our TallyPrime renewal services.',
      icon: 'arrow-clockwise'
    },
    {
      title: 'TallyPrime Rental',
      description: 'Renting TallyPrime is the ideal option for companies looking for budget and flexibility. You can utilize all the capabilities of TallyPrime by renting it from Digisoft without making a sizable initial outlay.',
      icon: 'calendar-check'
    }
  ];

  const tallyPrimeFeatures = [
    {
      title: 'Tally Software Services',
      image: imagePaths.tallyFeatureImg,
      description: 'Enjoy the valued-added features from free upgrades to connected services, enhancing business productivity',
      ctaText: 'Get Demo'
    },
    {
      title: 'TallyPrime on Mobile',
      image: imagePaths.tallyMobileImg,
      description: 'Business doesn\'t stop when you leave the office in today\'s fast-paced environment. You can generate reports, access your financial data, and make important decisions from anywhere with TallyPrime on Mobile. Utilize the benefits of mobility to stay constantly connected to your business.',
      ctaText: 'Get Demo'
    },
    {
      title: 'TallyPrime on AWS',
      image: imagePaths.tallyAwsImg,
      description: 'Utilise TallyPrime on AWS to benefit from the scalability and dependability of cloud computing. This solution offers safe, cloud-based access to TallyPrime, facilitating smooth communication, data backup, and simple administration. Improve your financial operations by using the cloud.',
      ctaText: 'Get Demo'
    }
  ];

  // Single User pricing cards
  const singleUserPricing = [
    {
      id: "TE9_RENT_1_1",
      period: "1 Month",
      price: "750",
      oldPrice: "",
      discount: "",
      effectivePrice: "",
      itemId: "41628",
      isLifetime: false
    },
    {
      id: "TE9_RENT_1_3",
      period: "3 Month",
      price: "2,138",
      oldPrice: "2,250",
      discount: "5",
      effectivePrice: "Effective price 712.5/Month",
      itemId: "41628",
      isLifetime: false
    },
    {
      id: "TE9_RENT_1_12",
      period: "12 Month",
      price: "8,100",
      oldPrice: "9,000",
      discount: "10",
      effectivePrice: "Effective price 675/Month",
      itemId: "41628",
      isLifetime: false
    },
    {
      id: "TE9_1",
      period: "Lifetime",
      price: "22,500",
      oldPrice: "",
      discount: "",
      effectivePrice: "",
      itemId: "41581",
      isLifetime: true
    }
  ];

  // Multi User pricing cards
  const multiUserPricing = [
    {
      id: "TE9_RENT_2_1",
      period: "1 Month",
      price: "2,250",
      oldPrice: "",
      discount: "",
      effectivePrice: "",
      itemId: "41629",
      isLifetime: false
    },
    {
      id: "TE9_RENT_2_3",
      period: "3 Month",
      price: "6,413",
      oldPrice: "6,750",
      discount: "5",
      effectivePrice: "Effective price 2137.5/Month",
      itemId: "41629",
      isLifetime: false
    },
    {
      id: "TE9_RENT_2_12",
      period: "12 Month",
      price: "24,300",
      oldPrice: "27,000",
      discount: "10",
      effectivePrice: "Effective price 2025/Month",
      itemId: "41629",
      isLifetime: false
    },
    {
      id: "TE9_2",
      period: "Lifetime",
      price: "67,500",
      oldPrice: "",
      discount: "",
      effectivePrice: "",
      itemId: "41582",
      isLifetime: true
    }
  ];

  const faqs = [
    {
      question: 'What is TallyPrime?',
      answer: 'TallyPrime is a popular business accounting and financial management software developed by Tally Solutions. It is designed to simplify complex accounting processes and provide businesses with the tools they need for effective financial management.'
    },
    {
      question: 'Key Features of TallyPrime?',
      answer: 'TallyPrime offers a range of features, including accounting, inventory management, invoicing, payroll processing, financial reporting, and compliance management. It also provides a simple and intuitive user interface.'
    },
    {
      question: 'Is TallyPrime suitable for small businesses?',
      answer: 'Yes, TallyPrime is suitable for small, medium, and large businesses. It is scalable, making it a valuable tool for startups and growing enterprises as well.'
    },
    {
      question: 'Can I access TallyPrime remotely?',
      answer: 'Yes, TallyPrime supports remote access through the Tally.NET service, enabling you to work from different locations and collaborate with your team seamlessly.'
    }
  ];

  // Hero section background style
  const heroBackgroundStyle = {
    backgroundImage: `url(${imagePaths.heroBgImg})`,
      backgroundPosition: 'center center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  opacity: 0.1,
  margin: 0,
    padding: 0
  };

  // CTA section background style
  const ctaBackgroundStyle = {
    backgroundImage: `url(${imagePaths.testimonialsBgImg})`,
    backgroundPosition: 'center center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    opacity: '40%'
  };

  return (
    <div id="details-tallyprime" className="tallyprime-page p-0">
      {/* Hero Section */}
      <section className="tallyprime-hero pt-5 section dark-background position-relative">
        <div style={heroBackgroundStyle}></div>
        <div className="container py-5">
          <div className="row py-5 align-items-center">
            <div className="col-lg-6">
              <h1 className="display-5 fw-bold mb-4">TallyPrime</h1>
              <p className="lead mb-4">
                At Digisoft, we understand that effective financial management is the foundation of every flourishing company. 
                One of the main pillars of our expertise is TallyPrime, which is more than simply accounting software and gives 
                businesses the ability to make wise decisions and keep their finances transparent.
              </p>
              <a href="#contact" className="btn btn-primary btn-lg">Get Started</a>
            </div>
            <div className="col-lg-6 text-center">
              <img 
                src={imagePaths.heroImg} 
                alt="TallyPrime Solution" 
                className="img-fluid" 
                style={{ maxHeight: '400px' }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Why TallyPrime Section */}
      <section className="why-tallyprime py-5 section light-background">
        <div className="container py-5">
          <SectionTitle 
            title="Why TallyPrime?" 
            description1="Trusted By" 
            description2="Millions" 
          />
          
          <div className="row mt-5 align-items-center">
            <div className="col-lg-6 mb-4 order-2 order-lg-1">
              <p className="lead">
                Millions of organizations around the world rely on the powerful, user-friendly, 
                and feature-rich accounting software TallyPrime. Millions of businesses throughout 
                the world rely on TallyPrime, a powerful, intuitive, and feature-rich accounting program.
              </p>
              <div className="d-flex align-items-center mt-4 mb-3">
                <div className="me-3 text-primary">
                  <i className="bi bi-check-circle-fill fs-4"></i>
                </div>
                <p className="mb-0">Intuitive and easy-to-use interface</p>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="me-3 text-primary">
                  <i className="bi bi-check-circle-fill fs-4"></i>
                </div>
                <p className="mb-0">Comprehensive accounting & inventory management</p>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="me-3 text-primary">
                  <i className="bi bi-check-circle-fill fs-4"></i>
                </div>
                <p className="mb-0">Robust compliance handling (GST, TDS, etc.)</p>
              </div>
              <div className="d-flex align-items-center mb-3">
                <div className="me-3 text-primary">
                  <i className="bi bi-check-circle-fill fs-4"></i>
                </div>
                <p className="mb-0">Scalable for businesses of all sizes</p>
              </div>
            </div>
            <div className="col-lg-6 mb-4 order-1 order-lg-2 text-center">
              <img 
                src={imagePaths.tallyCloudImg} 
                alt="TallyPrime Cloud" 
                className="img-fluid rounded" 
                style={{ 
                  maxWidth: '90%',
                  height: 'auto'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* TallyPrime Solutions Section */}
      <section className="tallyprime-solutions py-5 section">
        <div className="container py-5">
          <SectionTitle 
            title="TallyPrime Solutions" 
            description1="Our" 
            description2="Offerings" 
          />
          
          <div className="row mt-5">
            {tallyPrimeSolutions.map((solution, index) => (
              <div key={index} className="col-md-6 col-lg-4 mb-4">
                <div className="card h-100 border-0 shadow-sm">
                  <div className="card-body p-4">
                    <div 
                      className="solution-icon mb-3 p-3 rounded-circle text-white d-flex align-items-center justify-content-center" 
                      style={{ 
                        backgroundColor: '#7b00ff',
                        width: '60px',
                        height: '60px',
                        minWidth: '60px'
                      }}
                    >
                      <i className={`bi bi-${solution.icon} fs-4`}></i>
                    </div>
                    <h3 className="card-title h4">{solution.title}</h3>
                    <p className="card-text text-muted">{solution.description}</p>
                    <a href="#contact" className="btn btn-outline-primary mt-3">Learn More</a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="bg-light-sky py-5">
        <div className="container py-5">
          <SectionTitle 
            title="TallyPrime Pricing" 
            description1="Flexible" 
            description2="Plans" 
          />
          
          <div className="row">
            <div className="col-12 mx-auto">
              <div className="py-5">
                {/* Tabs */}
                <div className="d-flex justify-content-center mb-4">
                  <div className="pricing-tab-container d-none d-md-flex">
                    <button 
                      className={`pricing-tab-btn ${activeTab === 'single' ? 'active' : ''}`} 
                      onClick={() => switchPricingTab('single')}
                    >
                      Single User
                    </button>
                    <button 
                      className={`pricing-tab-btn ${activeTab === 'multi' ? 'active' : ''}`} 
                      onClick={() => switchPricingTab('multi')}
                    >
                      Multi User
                    </button>
                  </div>
                  
                  <div className="px-5 py-1 position-relative d-block d-md-none">
                    <select 
                      className="form-select py-2 rounded-pill" 
                      style={{ backgroundColor: '#0d6efd', color: '#fff' }} 
                      value={activeTab}
                      onChange={(e) => switchPricingTab(e.target.value)}
                    >
                      <option value="single">Single User</option>
                      <option value="multi">Multi User</option>
                    </select>
                  </div>
                </div>

                {/* Single User Cards */}
                <div id="pricing-single" className={`pricing-section row ${activeTab === 'single' ? 'active' : ''}`}>
                  <div className="col-12 mb-4">
                    <div className="col-md-8 text-center text-muted mx-auto">
                      <p>
                        TallyPrime Silver - Suitable for businesses that need TallyPrime on a single PC
                      </p>
                    </div>
                  </div>
                  <div className="row justify-content-center align-items-stretch px-0">
                    {singleUserPricing.map((plan, index) => (
                      <div key={index} className="col-sm-12 col-md-6 col-xl-3 my-3 my-xl-0">
                        <div className="pricing-card px-0 position-relative">
                          {plan.discount && (
                            <span className="off-tag">
                              {plan.discount}% OFF
                            </span>
                          )}
                          <div className="px-3">
                            <h5 className="mb-2">{plan.period}</h5>
                            <h2 className="font-weight-bold text-dark mt-2 mb-0 price-value">
                              {plan.oldPrice && <del className="text-muted me-2 price-deleted">₹ {plan.oldPrice}</del>}
                              <span className="price-currency">₹</span>
                              <span className="price-amount">{plan.price}</span>
                            </h2>
                            <p className="mb-0"><small>+18% GST</small></p>
                            <p className={`pricing-effective mt-2 ${plan.effectivePrice ? 'visible' : 'invisible'}`}>
                              {plan.effectivePrice}
                            </p>
                          </div>
                          <div className="py-4 px-3">
                            <button className="btn btn-primary w-100">
                              Buy Now
                              <i className="bi bi-arrow-up-right ms-2"></i>
                            </button>
                          </div>
                          <div className="px-3 py-3 bg-light-cream">
                            <ul className="pricing-checklist">
                              <li>{plan.discount ? `Budget friendly - Flat ${plan.discount}% off` : 'Affordable Plan'}</li>
                              <li>Free expert assistance</li>
                              <li>{plan.isLifetime ? 'Includes 1-year TSS' : 'Includes TSS'}</li>
                              <li>{plan.isLifetime ? 'Lifetime license' : 'Switch to lifetime license'}</li>
                            </ul>
                          </div>
                          <div className="pricing-features mt-3 px-3">
                            <h6>What you get:</h6>
                            <ul>
                              <li>Fully loaded with all features</li>
                              <li>Invoicing & accounting</li>
                              <li>Inventory management</li>
                              <li>GST and compliance</li>
                              <li>Banking and cashflow</li>
                              <li>e-Invoicing and e-way bills</li>
                              <li>Connected services</li>
                              <li>Business operation</li>
                              {plan.isLifetime && (
                                <li className="text-primary hover-text">
                                  Zero cost EMI available
                                  <span>Specific EMI details, including banks and tenure options, will be presented at the payment page</span>
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Multi User Cards */}
                <div id="pricing-multi" className={`pricing-section row ${activeTab === 'multi' ? 'active' : ''}`}>
                  <div className="col-12 mb-4">
                    <div className="col-md-8 text-center text-muted mx-auto">
                      <p>
                        TallyPrime Gold - Perfect for businesses needing multi-user access on multiple PCs
                      </p>
                    </div>
                  </div>
                  <div className="row justify-content-center align-items-stretch px-0">
                    {multiUserPricing.map((plan, index) => (
                      <div key={index} className="col-sm-12 col-md-6 col-xl-3 my-3 my-xl-0">
                        <div className="pricing-card px-0 position-relative">
                          {plan.discount && (
                            <span className="off-tag">
                              {plan.discount}% OFF
                            </span>
                          )}
                          <div className="px-3">
                            <h5 className="mb-2">{plan.period}</h5>
                            <h2 className="font-weight-bold text-dark mt-2 mb-0 price-value">
                              {plan.oldPrice && <del className="text-muted me-2 price-deleted">₹ {plan.oldPrice}</del>}
                              <span className="price-currency">₹</span>
                              <span className="price-amount">{plan.price}</span>
                            </h2>
                            <p className="mb-0"><small>+18% GST</small></p>
                            <p className={`pricing-effective mt-2 ${plan.effectivePrice ? 'visible' : 'invisible'}`}>
                              {plan.effectivePrice}
                            </p>
                          </div>
                          <div className="py-4 px-3">
                            <button className="btn btn-primary w-100">
                              Buy Now
                              <i className="bi bi-arrow-up-right ms-2"></i>
                            </button>
                          </div>
                          <div className="px-3 py-3 bg-light-cream">
                            <ul className="pricing-checklist">
                              <li>{plan.discount ? `Budget friendly - Flat ${plan.discount}% off` : 'Affordable Plan'}</li>
                              <li>Free expert assistance</li>
                              <li>{plan.isLifetime ? 'Includes 1-year TSS' : 'Includes TSS'}</li>
                              <li>{plan.isLifetime ? 'Lifetime license' : 'Switch to lifetime license'}</li>
                            </ul>
                          </div>
                          <div className="pricing-features mt-3 px-3">
                            <h6>What you get:</h6>
                            <ul>
                              <li>Fully loaded with all features</li>
                              <li>Invoicing & accounting</li>
                              <li>Inventory management</li>
                              <li>GST and compliance</li>
                              <li>Banking and cashflow</li>
                              <li>e-Invoicing and e-way bills</li>
                              <li>Connected services</li>
                              <li>Business operation</li>
                              {plan.isLifetime && (
                                <li className="text-primary hover-text">
                                  Zero cost EMI available
                                  <span>Specific EMI details, including banks and tenure options, will be presented at the payment page</span>
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* TallyPrime Features Section */}
      <section className="tallyprime-features py-5 section light-background">
        <div className="container py-5">
          <div className="container section-title" data-aos="fade-up">
            <h2>Do more with TallyPrime</h2>
            <div>
              <span>Advanced</span> <span className="description-title">Capabilities</span>
            </div>
          </div>
          <p className="text-center mb-5">Power your TallyPrime with advanced capabilities designed to boost your business productivity and streamline operations.</p>
          <div className="row g-4 mt-2">
            {/* Tally Software Services Card */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 border border-1 border-secondary-subtle" style={{ borderRadius: "8px" }}>
                <div className="card-body p-0">
                  <div className="text-center p-4">
                    <img 
                      src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/tally-software-service/prime-page-banner-right-img.webp" 
                      alt="Tally Software Services" 
                      className="img-fluid mb-4" 
                      style={{ height: "180px", objectFit: "contain" }}
                    />
                  </div>
                  
                  <hr className="my-0" style={{ opacity: "0.2" }} />
                  
                  <div className="p-4">
                    <div className="d-flex align-items-center mb-3">
                      
                      <h3 className="h4 mb-0">Tally Software Services &nbsp;</h3>
                      <img 
                        src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/tss-logo.svg" 
                        alt="TSS Logo"
                        style={{ height: "2rem", marginRight: "8px" }}
                      />
                    </div>
                    
                    <p className="text-muted mb-4">
                      Enjoy the valued-added features from free upgrades to connected services, enhancing business productivity.
                    </p>
                    
                    <Link to="/tally-software-service/" className="text-decoration-none" style={{ color: "#0d6efd", fontWeight: "600" }}>
                      Learn More 
                      <img 
                        src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/icons/arrow-up-right-blue.svg" 
                        alt="Arrow"
                        style={{ marginLeft: "6px", width: "16px", height: "16px" }}
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            
            {/* TallyPrime on AWS Card */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 border border-1 border-secondary-subtle" style={{ borderRadius: "8px" }}>
                <div className="card-body p-0">
                  <div className="text-center p-4">
                    <img 
                      src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/manage-your-business-from-anywhere-anydevice.webp" 
                      alt="TallyPrime on AWS" 
                      className="img-fluid mb-4" 
                      style={{ height: "180px", objectFit: "contain" }}
                    />
                  </div>
                  
                  <hr className="my-0" style={{ opacity: "0.2" }} />
                  
                  <div className="p-4">
                    <div className="d-flex align-items-center mb-3">
                      
                      <h3 className="h4 mb-0">TallyPrime powered by &nbsp;</h3>

                      <img 
                        src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/aws-icon.svg" 
                        alt="AWS Logo"
                        style={{ height: "2.5rem", marginRight: "10px" }}
                      />
                    </div>
                    
                    <p className="text-muted mb-4">
                      Access your TallyPrime from anywhere with secure cloud-based solution powered by AWS infrastructure for reliable performance.
                    </p>
                    
                    <Link to="/tallyprime-on-aws/" className="text-decoration-none" style={{ color: "#0d6efd", fontWeight: "600" }}>
                      Learn More 
                      <img 
                        src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/icons/arrow-up-right-blue.svg" 
                        alt="Arrow"
                        style={{ marginLeft: "6px", width: "16px", height: "16px" }}
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            
            {/* TallyPrime with WhatsApp Card */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card h-100 border border-1 border-secondary-subtle" style={{ borderRadius: "8px" }}>
                <div className="card-body p-0">
                  <div className="text-center p-4">
                    <img 
                      src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/tally-software-service/tallyprime-with-whatsapp.webp" 
                      alt="TallyPrime with WhatsApp" 
                      className="img-fluid mb-4" 
                      style={{ height: "180px", objectFit: "contain" }}
                    />
                  </div>
                  
                  <hr className="my-0" style={{ opacity: "0.2" }} />
                  
                  <div className="p-4">
                    <div className="d-flex align-items-center mb-3">
                      
                      <h3 className="h4 mb-0">TallyPrime with &nbsp;</h3>
                      <img 
                        src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/whatsapp-icon.svg" 
                        alt="WhatsApp Logo"
                        style={{ width: "7rem", marginRight: "10px" }}
                      />
                    </div>
                    
                    <p className="text-muted mb-4">
                      Get business insights and reports directly on WhatsApp. Make informed decisions on the go with instant data access.
                    </p>
                    
                    <Link to="/tallyprime-with-whatsapp-business/" className="text-decoration-none" style={{ color: "#0d6efd", fontWeight: "600" }}>
                      Learn More 
                      <img 
                        src="https://resources.tallysolutions.com/wp-content/themes/tally/assets/images/icons/arrow-up-right-blue.svg" 
                        alt="Arrow"
                        style={{ marginLeft: "6px", width: "16px", height: "16px" }}
                      />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Trusted By Companies */}
      <section className="trusted-by py-5 section">
        <div className="container py-5">
          <h2 className="text-center mb-5">Trusted by Companies</h2>
          <p className="text-center mb-5">Digisoft has the ideal TallyPrime solution for your company, whether you're seeking for mobility, scalability, customization, or specialized solutions.</p>
          <div className="logos-slider">
            <div className="logos-slide">
              <img src="/assets/img/clients-logo-01.png" alt="Client" className="client-logo" />
              <img src="/assets/img/clients-logo-02.png" alt="Client" className="client-logo" />
              <img src="/assets/img/clients-logo-03.png" alt="Client" className="client-logo" />
              <img src="/assets/img/clients-logo-04.png" alt="Client" className="client-logo" />
              <img src="/assets/img/clients-logo-01.png" alt="Client" className="client-logo" />
              <img src="/assets/img/clients-logo-02.png" alt="Client" className="client-logo" />
              <img src="/assets/img/clients-logo-03.png" alt="Client" className="client-logo" />
              <img src="/assets/img/clients-logo-04.png" alt="Client" className="client-logo" />
            </div>
          </div>
        </div>
      </section>

      {/* FAQs */}
      <section className="faqs py-5 section light-background">
        <div className="container py-5">
          <h2 className="text-center fw-bold mb-3">Frequently Asked Queries</h2>
          <p className="text-center lead mb-5">Frequently asked questions about the features and capabilities of TallyPrime.</p>
          
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="row g-4">
                {faqs.map((faq, index) => (
                  <div key={index} className="col-md-6" data-aos="fade-up" data-aos-delay={(index * 100)}>
                    <div className="faq-card h-100 p-4 bg-white rounded-3 shadow-sm border-top border-primary border-3">
                      <div className="d-flex align-items-center mb-3">
                        <div className="faq-icon me-3">
                          <i className={`bi bi-${index === 0 ? 'info-circle' : index === 1 ? 'gear' : index === 2 ? 'building' : 'laptop'} text-primary fs-3`}></i>
                        </div>
                        <h3 className="h5 fw-bold mb-0">{faq.question}</h3>
                      </div>
                      <div className="faq-answer">
                        <p className="mb-0 text-muted">{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="text-center mt-5">
            <a href="#contact" className="btn btn-outline-primary btn-lg">Have more questions?</a>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="cta py-5 section dark-background position-relative">
        <div 
          style={ctaBackgroundStyle} 
          className="position-absolute top-0 start-0 w-100 h-100"
        ></div>
        <div className="container py-5 text-center position-relative">
          <h2 className="mb-4">Ready to transform your financial management?</h2>
          <p className="mb-4 lead">Experience the power of TallyPrime with Digisoft's expert solutions and support.</p>
          <a href="#contact" className="btn btn-primary btn-lg">Contact Us Today</a>
          
          <div className="social-media-section mt-5">
            <div className="social-icons d-flex justify-content-center">
              <a href="https://www.facebook.com/DigisoftService/" className="mx-2" aria-label="Facebook" style={{ fontSize: "24px", color: "#fff" }}>
                <i className="fab fa-facebook"></i>
              </a>
              <a href="https://www.instagram.com/digisoft_services/" className="mx-2" aria-label="Instagram" style={{ fontSize: "24px", color: "#fff" }}>
                <i className="fab fa-instagram"></i>
              </a>
              <a href="https://www.linkedin.com/company/digisoftservices/" className="mx-2" aria-label="LinkedIn" style={{ fontSize: "24px", color: "#fff" }}>
                <i className="fab fa-linkedin"></i>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TallyPrime; 